import { jwtDecode } from 'jwt-decode';

const PATIENT_PROFILE_KEY = 'patient_profile';

export const savePatientSession = (patient = {}) => {
    const profile = {
        id: patient.id ?? null,
        mrno: patient.mrno || '',
        name: patient.name || '',
        mobile: patient.mobile || patient.contactNumber || '',
    };
    localStorage.setItem(PATIENT_PROFILE_KEY, JSON.stringify(profile));
    return profile;
};

export const clearPatientSession = () => {
    localStorage.removeItem(PATIENT_PROFILE_KEY);
};

export const getPatientSession = () => {
    try {
        const raw = localStorage.getItem(PATIENT_PROFILE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed?.mrno) return parsed;
        }
    } catch (err) {
        console.error('Failed to parse patient session:', err);
    }

    // Fallback: decode JWT (covers older sessions before patient_profile existed)
    try {
        const token = localStorage.getItem('kiosk_token')?.replace(/^"(.*)"$/, '$1');
        if (!token) return null;
        const decoded = jwtDecode(token);
        if (!decoded?.mrno) return null;
        const profile = {
            id: decoded.id ?? null,
            mrno: decoded.mrno || '',
            name: decoded.name || '',
            mobile: decoded.mobile || '',
        };
        localStorage.setItem(PATIENT_PROFILE_KEY, JSON.stringify(profile));
        return profile;
    } catch (err) {
        console.error('Failed to decode patient token:', err);
        return null;
    }
};

export const savePatientSessionFromToken = (token) => {
    try {
        const cleanToken = String(token || '').replace(/^"(.*)"$/, '$1');
        if (!cleanToken) return null;
        const decoded = jwtDecode(cleanToken);
        return savePatientSession({
            id: decoded.id,
            mrno: decoded.mrno,
            name: decoded.name,
            mobile: decoded.mobile,
        });
    } catch (err) {
        console.error('Failed to save patient session from token:', err);
        return null;
    }
};
